import gql from 'graphql-tag';
import {flowRight as compose} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {withTranslation} from 'react-i18next';
import {withRouter} from 'react-router';
import {dateFormatFR} from '../../../../utils';
import DataTable from '../../../../common/components/Datatable/Datatable';
import DisplayFileSize from '../../../../common/components/DisplayFileSize';
import {FILTER_EXPRESSION_OPERATOR, FILTER_OPERATOR, ORDER_DIRECTION} from '../../../../common/constants';
import DisplayBrand from '../../../ticket/components/DisplayBrand';
import TicketRowAction from '../../../ticket/components/TicketRowActionAdmin';

const GRAPHQL_QUERY_RECEIPTS = gql`
    query receipts($criteria:CriteriaInput){
        receipts(criteria: $criteria){
            rows{
                id
                isFirstOrder
                userHasLoyaltyCard
                user{
                    id
                    firstName
                    lastName
                    email
                    birthDate
                    civility
                }
                brand{
                    id
                    name
                    createdAt
                    updatedAt
                }
                file{
                    id
                    key
                    token
                    mimeType
                    size
                }
                checkout{
                    id
                    name
                    merchant{
                        id
                        contactEmail
                        businessName
                        user{
                            id
                            firstName
                            lastName
                        }
                    }
                }
                tags {
                  id
                  rows {
                    id
                    name
                  }
                }
                comments {
                  id
                  review
                }
                rating
                createdAt
            }
            total
            id
        }
    }
`;

const columns = t => [
  {
    Header: '#',
    accessor: 'id',
    sortable: true,
  },
  {
    Header: t('merchantName'),
    accessor: 'checkout.merchant.businessName',
    sortable: true,
  },
  {
    Header: t('brand'),
    Cell: ({cell}) => <DisplayBrand brand_name={cell.value}/>,
    accessor: 'brand.name',
    sortable: true,
  },
  {
    Header: t('email'),
    accessor: 'checkout.merchant.contactEmail',
    sortable: true,
  },
  {
    Header: t('creation'),
    Cell: ({cell}) => dateFormatFR(cell.value),
    accessor: 'createdAt',
    sortable: true,
  },
  {
    Header: t('fileSize'),
    Cell: ({cell}) => <DisplayFileSize file={cell.value}/>,
    accessor: 'file',
    sortable: true,
    sortKey: 'file.size',
  },
  {
    Header: t('action'),
    Cell: ({cell}) => <TicketRowAction receipt={cell.value}/>,
    accessor: row => row,
  },
];

const Receipts = ({match, t}) => {
  const id = match.params.id || null;
  const initialFilters = {
    expressions: [{
      operator: FILTER_EXPRESSION_OPERATOR.And,
      filters: [{
        field: 'checkoutId',
        value: id,
      }],
    }],
    relations: ['user', 'brand', 'merchant', 'file'],
  };
  const [advancedFilters, setAdvancedFilters] = React.useState(id ? initialFilters : null);
  const onSearch = search => setAdvancedFilters({
    expressions: [
      ...initialFilters.expressions,
      {
        operator: FILTER_EXPRESSION_OPERATOR.Or,
        filters: [{
          field: 'receipt.id',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }, {
          field: 'user.email',
          operator: FILTER_OPERATOR.Like,
          value: `%${search}%`,
        }],
      }],
    relations: ['user', 'brand', 'merchant', 'file'],
  });

  return (
    <DataTable
      columns={columns(t)}
      query={GRAPHQL_QUERY_RECEIPTS}
      keyResult="receipts"
      defaultSort={{field: 'createdAt', direction: ORDER_DIRECTION.DESC}}
      onSearch={onSearch}
      advancedFilters={advancedFilters}/>
  );
};

Receipts.propTypes = {
  t: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
};

export default compose(
  withTranslation('checkout'),
  withRouter,
)(Receipts);
